import { Incident } from '../domain/incident.model';
import { OtherIncidentResponseDto } from './dto/other-incident-response.dto';

export const mapIncidentDtoToDomain = (dto: OtherIncidentResponseDto): Incident => ({
  id: dto.id,
  incidentDate: dto.incidentDate,
  flightNumber: dto.flightNum,
  appVersion: dto.incidentAppVersion,
  employeeId: dto.employeeId,
  employeeRole: dto.employeeRole,
  departure: dto.flightDeparture,
  arrival: dto.flightArrival,
  state: dto.stateColumbus ?? '',
  employeeName: dto.employeeName,
  employeeEmail: dto.employeeEmail,
  employeeFleet: dto.employeeFleet,
  category: dto.incidentCategory,
  type: dto.incidentType,
  comment: dto.incidentComment,

  incidentImage: dto.incidentImage ?? '',
  incidentImageKey: dto.incidentImageKey ?? '',

  flightDate: dto.flightDate,
  iosVersion: dto.incidentIosVersion,
  linkColumbus: dto.linkColumbus ?? '',

  flightFleet: dto.employeeFleet,
  flightMat: dto.flightMat,
  incidentColumbusNumber: dto.incidentColumbusNumber ?? '',
  idEmployeeAnswered: dto.idEmployeeAnswered ?? '',
  fullNameAnswered: dto.fullNameAnswered ?? '',
  dateAnswered: dto.dateAnswered ?? '',
  categorization: dto.categorization ?? '',
  message: '',
});
